/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Text from 'components/Text';

import type { TextElement } from 'components/Text';

import './SchoolViewHeading.scss';

type Props = {
  children: React.Node,
  cta?: React.Node,
  element?: TextElement,
  subtext?: React.Node,
};

export default function SchoolViewHeading({ cta, children, element, subtext, ...props }: Props) {
  return (
    <header className="SchoolViewHeading">
      <Text
        {...props}
        element={element}
        font="serif"
        className={cx('SchoolViewHeading-title', element && `SchoolViewHeading-title--${element}`)}>
        {children}
      </Text>
      {subtext && (
        <Text element="p" size="small" className="SchoolViewHeading-subtext">
          {subtext}
        </Text>
      )}
      {cta && (
        <Text align="center" element="div" className="SchoolViewHeading-cta">
          {cta}
        </Text>
      )}
    </header>
  );
}

SchoolViewHeading.defaultProps = {
  element: 'h2',
};
